export const convertToHtml = (text) => ({
    __html: text.split("\n").join("<br><br>"),
});
